module.exports = __webpack_public_path__ + "static/pie7-ce02cf5e99e4cfcdae40c404aeb4c7eb.png";